import type { ComponentProps, FC, ReactNode } from 'react'

import { ChevronDown } from 'lucide-react'
import { cn } from '@/lib/utils'

const NativeSelect: FC<ComponentProps<'select'>> = ({ className, ...props }): ReactNode => {
    return (
        <div
            data-slot='native-select-wrapper'
            className={cn('relative w-full has-[select:disabled]:opacity-55', className)}
        >
            <select
                data-slot='native-select'
                className='h-12 w-full min-w-0 cursor-pointer appearance-none rounded-lg border border-input bg-card py-0 pr-10 pl-3.5 text-base text-foreground transition-colors hover:border-foreground/60 disabled:cursor-not-allowed aria-invalid:border-destructive'
                {...props}
            />

            <ChevronDown
                aria-hidden='true'
                className='pointer-events-none absolute top-1/2 right-3.5 size-4 -translate-y-1/2 text-muted-foreground'
            />
        </div>
    )
}

const NativeSelectOption: FC<ComponentProps<'option'>> = ({ className, ...props }): ReactNode => {
    return (
        <option
            data-slot='native-select-option'
            className={cn('bg-[Canvas] text-[CanvasText]', className)}
            {...props}
        />
    )
}

export { NativeSelect, NativeSelectOption }
